/**
 * Site chrome config derived from build-time env (PRD v0.4: no settings DB —
 * changing these values needs a redeploy).
 */
import { env } from './env';

/** Giving URL (VITE_GIVEBUTTER_URL, set in netlify.toml); null when unset. */
export const givingUrl: string | null = env.VITE_GIVEBUTTER_URL || null;

/** A Givebutter campaign link, e.g. https://givebutter.com/6stFXW (captures the code). */
const GIVEBUTTER_CAMPAIGN = /^https:\/\/givebutter\.com\/([A-Za-z0-9_-]+)\/?$/;

/** Givebutter's embeddable form for the campaign (givebutter.com/embed/c/<code>, which,
 *  unlike the campaign page, allows framing). Null for any other kind of giving link: the
 *  site then only links out to it. */
export function givebutterEmbedFor(url: string | null): string | null {
  const code = url?.match(GIVEBUTTER_CAMPAIGN)?.[1];
  return code ? `https://givebutter.com/embed/c/${code}` : null;
}

export const givingEmbedUrl: string | null = givebutterEmbedFor(givingUrl);

/** Adds Givebutter's `amount` parameter (whole dollars; it pre-fills the form) to a
 *  Givebutter URL. Other providers' URLs are returned unchanged. */
export function withGivingAmount(url: string, amount?: number | null): string {
  if (!amount || !/^https:\/\/givebutter\.com\//.test(url)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}amount=${amount}`;
}

/** A gift amount from a query value: whole dollars, 1–100000, else null. */
export function parseGivingAmount(value: string | null | undefined): number | null {
  if (!value || !/^\d{1,6}$/.test(value)) return null;
  const n = Number(value);
  return n >= 1 && n <= 100000 ? n : null;
}

/** Public contact email (Footer, Get Help, Privacy). */
export const contactEmail: string = env.VITE_CONTACT_EMAIL;

/** Public call/text number; null until the board confirms one (PRD OQ 11/14). */
export const contactPhone: string | null = env.VITE_CONTACT_PHONE.trim() || null;
